import { useUserPermissions } from '../contexts/UserPermissionsContext';

export function useUpdatePermissions() {
  const { isViewer, isEditor, isAdmin, userPermissions } = useUserPermissions();

  // Determine if user can edit
  const canEdit = isEditor || isAdmin;

  // Determine if user can view
  const canView = isViewer || isEditor || isAdmin;

  return {
    canEdit,
    canView,
    isViewer,
    isEditor,
    isAdmin,
    userPermissions,
  };
}
